import { ComponentPropsWithoutRef } from 'react';
import { StyledTH } from './styles';

export const TH = (props: ComponentPropsWithoutRef<'th'>) => <StyledTH {...props} />;
